import React, { useEffect, useState } from "react";
import {  TileLayer, GeoJSON, MapContainer,LayersControl, LayerGroup, Popup, Marker } from "react-leaflet";
import { icon } from 'leaflet';
import { renderToString } from 'react-dom/server';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faList,
  faStepBackward,
  faFastBackward,
  faStepForward,
  faFastForward,
  faSearch,
  faTimes,
  faMapLocationDot,
  faClockFour,
  faCalendarDay,
  faClipboardList,
  faFireExtinguisher,
  faTruckMedical,
  faFireAlt,
  faPersonChalkboard,
  faFireBurner,
  faHouseFire,
  faDumpsterFire,
  faHouseLock,
  faHouseFloodWater,
  faExplosion,
  faHeartCircleBolt,
  faSprayCanSparkles,
  faCarBurst,
  faSuitcaseMedical,
  faPersonSwimming,
  faOilCan,
  faRoadCircleExclamation,
  faTree,
  faTruckArrowRight,
  faScrewdriverWrench,
  faWrench,
  faFire,
  faCircleRadiation,
  faRadiation,
  faTowerCell,
  faCat
} from "@fortawesome/free-solid-svg-icons";
import L from 'leaflet';
import axios from "axios";
import { useNavigate } from "react-router-dom";
export default function Map(){
    const [position, setPosition] = useState([ 51.164981, 14.5066482 ]);
    const url=process.env.REACT_APP_PUBLIC_BACKEND;
    const [missions, setMissions]=useState([]);
    const navigate=useNavigate();

    useEffect(()=> {  
      findAllMissions();  
    },[]);
    
    function findAllMissions() {
      axios
        .get(
          url+"/missions/public?pageNumber=" +
            0 +
            "&pageSize=" +
            10 +
            "&sortBy=date&sortDir=" +
            "desc"
        )
        .then((response) => response.data)
        .then((data) => {
          //console.log(data);
         setMissions(data.content);
        })
        .catch((error) => {
          console.log(error);
        });
    }


    const customIcon = icon({
        iconUrl: 'https://unpkg.com/leaflet@1.6.0/dist/images/marker-icon.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });
      function customMarkerIcon(cat){
        return(L.divIcon({
          html: renderToString(getCatIcon(cat)),
          className: 'mission-icon',
          iconSize: [55, 71],
          iconAnchor: [5, 10],
          popupAnchor: [1, -34],
          shadowSize: [41, 41]
        }));}

      const boundaryGeoJSON = {
        "type": "Feature",
        "properties": {},
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [14.442667276171669,51.1509726346904],[14.445551585872229,51.15102840921066],[14.446161645239881,51.14944903737633],[14.447291556672374,51.148086356860965],[14.447567757861693,51.14695975697417],[14.446206202580855,51.144771243422674],[14.453326832483961,51.143449183719675],[14.456486413804765,51.14689222209368],[14.461744433532255,51.147903332851705],[14.462848398836286,51.15092036942313],[14.466136147368768,51.14733078946272],[14.46728577452836,51.147372835378334],[14.468908369219857,51.14574990551934],[14.477019319310362,51.14661829224866],[14.479327409418596,51.14447628571253],[14.480371937724664,51.142467406230296],[14.47969994348591,51.14065218422883],[14.4814928067928,51.13552720221834],[14.482148241011203,51.13282874732719],[14.479899904008908,51.13299551652608],[14.479893449807435,51.13159010893137],[14.475307697589772,51.13171931424514],[14.475133715797849,51.128364357200034],[14.478093402062667,51.1281464028803],[14.482706729073712,51.11820373897959],[14.486542557281227,51.11885669577053],[14.489798200569288,51.11942123836844],[14.493947575849537,51.11790070941346],[14.499336283183784,51.11713950262148],[14.505667318131463,51.11949041012763],[14.505647560284167,51.120914766424654],[14.510128830999234,51.120418483714154],[14.51373371970834,51.11939350493333],[14.51787417689248,51.11860227299485],[14.52337691848933,51.11898939592904],[14.52214071565827,51.13522427255228],[14.523146309535694,51.14052396879575],[14.525188469800373,51.14045358976829],[14.525958508277434,51.14271576749642],[14.524403773933876,51.143120777152674],[14.52680651183732,51.14554292944241],[14.527548557905272,51.148139462698154],[14.529747915327683,51.14756800324406],[14.529787009491214,51.15097271501135],[14.527777061858414,51.150924908152895],[14.52734016139509,51.155445334647354],[14.531036940858657,51.15528177155018],[14.530997826568111,51.15696812996213],[14.541335023712941,51.15769223839038],[14.543038734329917,51.160455363767106],[14.545045662864856,51.16129185265375],[14.545702531257167,51.16186513534046],[14.546652236695506,51.16404947498561],[14.548467082721432,51.1665852940411],[14.546128652717922,51.166122628636025],[14.544138354392809,51.16647087513048],[14.542395944111348,51.16555800853195],[14.538582743209938,51.16718567378424],[14.539495826720346,51.17139818476296],[14.542722754716062,51.17354829069902],[14.543424712324676,51.17730853703639],[14.542360114318846,51.179066427650355],[14.544514886171976,51.17928021953471],[14.545504065852494,51.18157076846174],[14.547785593507335,51.18126650031368],[14.54723572621953,51.183988786837055],[14.544920717247074,51.183257956835085],[14.546057371715806,51.1849396758878],[14.549565671654747,51.18505245641659],[14.55034961784794,51.188431384175445],[14.550037442354872,51.19092017627126],[14.552136305878701,51.19130699054154],[14.552023274073203,51.19426646007874],[14.551231742544944,51.19619517563221],[14.550177255382627,51.198069917031034],[14.550070927770648,51.20029025829091],[14.55249377401359,51.200278391907624],[14.553839586235322,51.20139413375356],[14.554579027895567,51.202571718059964],[14.554719439243742,51.203305926187454],[14.554054116450292,51.205236290021105],[14.553807549509989,51.206317691704484],[14.553018961194775,51.206845691652184],[14.552576903990419,51.20786234056514],[14.550274308305001,51.208874465491526],[14.547144811997988,51.20865085796552],[14.546489312636279,51.20905656900152],[14.544403073987839,51.2113894691887],[14.547936121014795,51.211925017782],[14.54532622952243,51.212592012872165],[14.5455457142835,51.21444063530958],[14.543189704276555,51.214404967865306],[14.53845888376889,51.21231574275981],[14.537070715072607,51.21235465939354],[14.534125158522524,51.210825369104704],[14.535143327054486,51.209672917323395],[14.531820861675437,51.20940906406872],[14.527379295617889,51.208156451338255],[14.524258774257337,51.20790345480126],[14.522839162811447,51.20840282983418],[14.520310860954933,51.208525819965864],[14.520054279216989,51.20788587835965],[14.518260083139,51.20803764969379],[14.515233109004205,51.208529076161106],[14.51029175014439,51.21026646527117],[14.508845467119444,51.212442531665566],[14.50619468519442,51.211983724465625],[14.503691837684451,51.21251485445885],[14.504258193406871,51.21379237471021],[14.5020423883699,51.21422532583944],[14.501067410034167,51.21191596591364],[14.495513446491232,51.212718551083036],[14.492878444596359,51.209456672275415],[14.49024706211705,51.21021325480115],[14.489515484771719,51.21024834162637],[14.4890401983158,51.20949213801228],[14.486904846200328,51.2100798990065],[14.486555979401647,51.20920494522163],[14.488569860172193,51.20879298001803],[14.488238477072242,51.20821839493703],[14.487601500796588,51.207321058925935],[14.49278790520972,51.20443195611349],[14.491017913632326,51.2034296313004],[14.490710290773002,51.202466529826424],[14.488398415500608,51.20293285723595],[14.48682700517388,51.20217551311871],[14.489003620009445,51.20163884244529],[14.488466558601994,51.201132682327746],[14.485667330978213,51.1999169356697],[14.48499775516313,51.19859768228072],[14.486683938725635,51.19753103597812],[14.487080866999873,51.19449424084035],[14.488538786251397,51.19310674032456],[14.49176985752204,51.192663071622974],[14.490936144861967,51.19131294265736],[14.492252545575605,51.18945689679157],[14.492516389883116,51.18687090100789],[14.489870023867534,51.18660985615986],[14.48748827075597,51.18735216892767],[14.486599776154867,51.18543295105088],[14.484110093203306,51.18549080946991],[14.483336387331772,51.183073211919336],[14.473508242492356,51.1832477185466],[14.475321198823629,51.18182551021396],[14.47715744679579,51.182006318241754],[14.477695316052671,51.18009584091849],[14.476573971872995,51.17806162138236],[14.477441686707516,51.17764587744051],[14.478201969422887,51.17678560040988],[14.47907472369171,51.17635060817193],[14.483443028521306,51.17493535060163],[14.484329365774336,51.17395444538411],[14.484445488070838,51.17266312177771],[14.481363033500376,51.171924683675876],[14.478075840198857,51.17286559314172],[14.476501177776903,51.170558476797396],[14.48464274938223,51.1684069545766],[14.485228864786206,51.167891391789524],[14.482887750863792,51.166835909438205],[14.480074496295469,51.1661208424336],[14.476812500568101,51.16485333279768],[14.470279406030834,51.16070551872128],[14.468486499890114,51.16068534513404],[14.456096670867547,51.161078540352364],[14.45522489565462,51.159432155856635],[14.45286247134296,51.15844891205025],[14.451197509044178,51.15925308608932],[14.448739801104665,51.156651150515856],[14.44665011240015,51.15667672048318],[14.445944925911855,51.15764661196508],[14.44325553231696,51.15702562414573],[14.44406269030283,51.15406106114447],[14.444635745498639,51.153221784652864],[14.442024540079926,51.153345979555134],[14.442667276171669,51.1509726346904]
            ]
          ]
        }
      };
     
      function getCatIcon (cat){
        if(cat==="Einsatzübung"){
        return(<FontAwesomeIcon icon={faPersonChalkboard} />)
        }
        else if(cat==="Küchenbrand"){
        return(<FontAwesomeIcon icon={faFireBurner} />)
        }
        else if(cat==="Gebäudebrand"){
        return(<FontAwesomeIcon icon={faHouseFire} />)
        }
        else if(cat==="Mülltonnenbrand"){
        return(<FontAwesomeIcon icon={faDumpsterFire} />)
        }
        else if(cat==="Unratbrand"||cat==="Flächenbrand"||cat==="Fahrzeugbrand"){
        return(<FontAwesomeIcon icon={faFireExtinguisher} />)
        }
        else if(cat==="Tierrettung"){
          return(<FontAwesomeIcon icon={faCat} />)
          }
        else if(cat==="Nottüröffnung"){
        return(<FontAwesomeIcon icon={faHouseLock} />)
        }
        else if(cat==="Hochwasser"){
        return(<FontAwesomeIcon icon={faHouseFloodWater} />)
        }
        else if(cat==="First Responder"){
        return(<><FontAwesomeIcon icon={faSuitcaseMedical} />
        <FontAwesomeIcon icon={faHeartCircleBolt} /></>)
        }
        else if(cat==="Chemieunfall"){
        return(<FontAwesomeIcon icon={faSprayCanSparkles} />)
        }
        else if(cat==="Explosion"){
        return(<FontAwesomeIcon icon={faExplosion} />)
        }
        else if(cat==="Verkehrsunfall"){
        return(<FontAwesomeIcon icon={faCarBurst} />)
        }
        else if(cat==="Wasserrettung"){
        return(<FontAwesomeIcon icon={faPersonSwimming} />)
        }
        else if(cat==="Auslaufende Betriebsstoffe"){
        return(<FontAwesomeIcon icon={faOilCan} />)
        }
        else if(cat==="Baum auf Straße"){
        return(<><FontAwesomeIcon icon={faRoadCircleExclamation} />
        <FontAwesomeIcon icon={faTree} /></>)
        }
        else if(cat==="Amtshilfe"||cat==="Unterstützung Rettungsdienst"){
        return(  <FontAwesomeIcon icon={faTruckMedical} />)
        }
        return(<FontAwesomeIcon icon={faTruckArrowRight} />)
        }
    return(<>
    <div >
  <MapContainer center={position}  zoom={11.5} zoomControl={true} maxZoom={14} scrollWheelZoom={false}  style={{zIndex: '0', width:'100%',height:'500px' ,borderBottomLeftRadius: "15px",borderBottomRightRadius: "15px" }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      />
      
      <LayersControl position="topright">
      <LayersControl.Overlay name="Standorte">
      <LayerGroup>
        <Marker position={[51.16880812538448, 14.505945469367203]} icon={customIcon}> 
          <Popup>
            Gemeindewehr Kubschütz
          </Popup>
        </Marker>
        <Marker position={[51.15049146724639, 14.512085187556787]} icon={customIcon}> 
          <Popup>
           Löschgruppe Soritz 
          </Popup>
        </Marker>
        <Marker position={[51.13993085851639, 14.510784644684819]} icon={customIcon}> 
          <Popup>
           Feuerwehr Rachlau 
          </Popup>
        </Marker>
        <Marker position={[51.1769330270982, 14.49544632213625]} icon={customIcon}> 
          <Popup>
           Löschgruppe Baschütz 
          </Popup>
        </Marker>
        <Marker position={[51.215577, 14.532819]} icon={customIcon}> 
          <Popup>
           Feuerwehr Kleinbautzen-Purschwitz-Preititz  
          </Popup>
        </Marker>
        </LayerGroup>
      </LayersControl.Overlay>
      <LayersControl.Overlay checked name="Einsatzgebiet Gemeinde Kubschütz">
        <LayerGroup>
        <GeoJSON data={boundaryGeoJSON} style={{ color: "green" }}/>
        </LayerGroup>
      </LayersControl.Overlay>
      <LayersControl.Overlay checked name="Letze Einsätze">
        <LayerGroup>       
        {missions.length !== 0 ? 
                  missions.map((mission) => (
                    <Marker
                    icon={customMarkerIcon(mission.category)}
                      position={mission.map.split(",")}>
                      <Popup autoPan minWidth={90}>
                     <a onClick={(e)=>(navigate("/einsaetze/details/"+mission.id))}>{mission.title}</a>
                      </Popup>
                    </Marker>
                )):null};
        </LayerGroup>
      </LayersControl.Overlay>
      </LayersControl>
      </MapContainer>
      </div>
</>
    )

}